export const WATCHLIST_WIZARD_KEY_HINT =
  'inline-flex min-w-5 items-center justify-center rounded-sm px-1 py-0.5 text-[10px] font-semibold text-foreground bg-foreground/10'
